import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const AuthRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params = searchParams.toString();
    navigate(params ? `/signin?${params}` : "/signin", { replace: true });
  }, [navigate, searchParams]);

  return null;
};

export default AuthRedirect;
